import { FilterBodyListConfig } from '@/components/FilterNew/components/Body/types';
import {
  UseFilterValuesType,
  UseOptionsQueryParams,
  UseOptionsQueryReturnType,
} from '@/components/FilterNew/types';
import { GroupStatusEnum, GroupTypeEnum, GroupUnion } from '@/types/schema';

import useFilterOptionsQuery from '../../hooks/useFilterOptionsQuery';
import useFilterValue from '../../hooks/useFilterValue';
import { useUserGroupFilterQuery } from './graphql/queries/generated/userGroupFilter';

export const getGroupFilterOption = ({ id, name }: Pick<GroupUnion, 'id' | 'name'>) => ({
  value: id,
  label: name,
});

const edgeKey = 'groups';

export const useUserGroupFilterValues: UseFilterValuesType = ({ value }) =>
  useFilterValue({
    value,
    useQuery: useUserGroupFilterQuery,
    edgeKey,
    variables: { filters: { ids: value } },
    getFilterOption: getGroupFilterOption,
  });

const useOptionsQuery = ({ searchText }: UseOptionsQueryParams): UseOptionsQueryReturnType =>
  useFilterOptionsQuery({
    useQuery: useUserGroupFilterQuery,
    edgeKey,
    variables: {
      filters: {
        name: searchText,
        status: [GroupStatusEnum.Published],
        systemGenerated: false,
        types: [GroupTypeEnum.UserCollection],
      },
    },
    getFilterOption: getGroupFilterOption,
  });

export const UserGroupEntityConfig: FilterBodyListConfig = {
  listVariant: 'multi-ungrouped-infinite',
  useOptionsQuery,
  useFilterValues: useUserGroupFilterValues,
};
